import React from 'react';
import { Link } from 'react-router-dom';

export default function RbacRolesPage() {
  return (
    <div className="dashboard-main-body">
      <div className="mb-24">
        <h4 className="mb-8">Roles y permisos</h4>
        <p className="text-secondary-light mb-0">
          Los roles funcionales y sus scopes se administran desde la plantilla de cada feature.
        </p>
      </div>
      <div className="alert alert-info">
        Los únicos roles Core son <code>superadmin</code> y <code>admin</code>. Para revisar
        o editar permisos, abre Features y selecciona la plantilla correspondiente.
      </div>
      <Link className="btn btn-primary" to="/features">Abrir Features</Link>
    </div>
  );
}
